import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import isAuthenticated from '../utils/session';

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      (isAuthenticated() ? (
        <Redirect
          to={{
            pathname: '/paychecks',
            search: '?page=1',
            state: { from: props.location },
          }}
        />
      ) : (
        <Component {...props} />
      ))
    }
  />
);


export default PublicRoute;

PublicRoute.propTypes = {
  location: PropTypes.object,
  component: PropTypes.func.isRequired,
};

PublicRoute.defaultProps = {
  location: null,
};



// WEBPACK FOOTER //
// ./src/components/PublicRoute.js